<template>
<div>
    <HeaderContact />
     <section class="service-wrapper py-5">
        <div class="container">
            <div class="bg-line"></div>
            <div class="row">
                <div class="col-12 border-bottom px-4 py-2">
                    <div class="row p-0">
                        <div class=" col-md-3 d-flex justify-content-center mb-3"> <img class="pic mb-md-0 mb-3" src="@/assets/images/team/KepalaCCEDUnila.jpg" alt=""> </div>
                        <div class="col-md-9 mt-5">
                            <h3 class="bold-800">Dr. Usep Syaipudin, M.S.Ak.</h3>
                            <p class="text">Kepala UPA PKK Universitas Lampung</p>
                            <!-- <div class="box d-flex justify-content-between align-items-center mt-3">
                            <div class="d-flex">
                              <span class="social-icon social-facebook"><i class="fa fa-facebook-square"></i></span>
                              <span class="social-icon social-google"><i class="fa fa-google"></i></span>
                              <span class="social-icon social-linkedin"><i class="fa fa-linkedin"></i></span>
                              <span class="social-icon social-instagram"><i class="fa fa-instagram"></i></span>
                              <span class="social-icon social-twitter"><i class="fa fa-twitter"></i></span>
                          </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-12 py-2 px-7">
                    <div class="row">
                        <div class="col-12">
                                <div class="border-bottom py-2">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <p class="p-blue">Dr. Nur Efendi, S.Sos., M.Si.</p>
                                            <p class="textmuted">Kepala Divisi Tracer Study dan Jaminan Mutu</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <div class="col-12">
                            </div>
                        <div class="col-12">
                                <div class="border-bottom py-2">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <p class="p-blue">Ade Imba Wahyu</p>
                                            <p class="textmuted">Staff</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <div class="col-12">
                                <div class="border-bottom py-2">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <p class="p-blue">Restia Permata Sari</p>
                                            <p class="textmuted">Staff</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                </div>
            </div>
        </div>

    <Surveyor />
    </section>

</div>
</template>

<script>
import HeaderContact from "@/components/hero/HeaderContact.vue";
import Surveyor from "@/components/datatable/Surveyor.vue";


export default {
  name: "Contact",
  components: {
     HeaderContact, Surveyor
  }

};
</script>

<style scoped>

.container {
    margin: 20px auto;
    padding: 0;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
    -webkit-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 6px 10px 23px -4px rgba(0, 0, 0, 0.75)
}

.social-icon {
    height: 30px;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 14px;
    border-radius: 7px;
    margin-right: 11px;
    cursor: pointer
}

.social-twitter {
    background-color: #55acee
}

.social-facebook {
    background-color: #3b5999
}

.social-linkedin {
    background-color: #0077B5
}

.social-google {
    background-color: #dd4b39
}

.social-instagram {
    background-color: #dd4b39
}

.social-icon i {
    transition: 0.4s all
}

.social-icon:hover i {
    transform: scale(1.1)
}

.bg-line {
    background-color: #003E29;
    height: 10px;
    margin-bottom: 20px
}

.container img.pic {
    height: 150px;
    width: 135px;
    /* border: 5px solid #010D4A;
    border-radius: 50%; */

}

.textmuted {
    font-size: 13px;
    color: #8d8d8d
}

.h-blue {
    color: #010D4A;
    font-size: 20px
}

.p-blue {
    color: #010D4A;
    font-size: 16px
}

.px-9 {
    padding: 0 50px
}

.bg {
    background-color: #ddd;
    border-radius: 25px;
    padding: 2px 8px;
    font-size: 11px
}

</style>
